var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarMedium = function SvgStarMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 8 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00CCBC",
    d: "m3.937 0 .806 2.992 2.992.805-2.992.806-.806 2.992-.805-2.992L.14 3.797l2.992-.805z"
  })));
};
export { SvgStarMedium as ReactComponent };
export default __webpack_public_path__ + "fonts/star-medium-c3841610c6bdae471c295ff747bae969.svg";